export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export type AllowedLanguages = 'en' | 'mk' | 'sr-Cyrl' | 'sr-Latn' | 'sq';

export function changeLanguage(language: AllowedLanguages) {
  return { type: CHANGE_LANGUAGE, language };
}
